<template>
  <div class="slide" id="slide_thanks" v-show="isVisibleSlide('thanks')">
    <!-- Variant 1 -->
    <div class="slide-content">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="content-wrapper">
              <div>
                <p><strong>No problem.<br />Thanks for taking the quiz.</strong></p> 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Thanks',
  props: ['gotoSlide', 'isVisibleSlide', 'analytics']
}
</script>

<style scoped lang="scss">
.slide-content {
  .container {
    box-shadow: 0px 0px 10px rgba(70,70,70,0.1);
    text-align: center;
    @media only screen and (max-width: 768px) {
      box-shadow: none;
    }
    .content-wrapper {
      margin: 250px auto 250px auto;
      max-width: 650px;
      @media only screen and (max-width: 1100px) {
        margin: 50px auto;
      }
      @media only screen and (max-width: 768px) {
        margin: 30px auto;
      }
    }
  }
  &.variant2 {
    .container {
      box-shadow: none;
      .content-wrapper {
      }
    }
  }
  p {
    font-size: 17px;
    &.highlight {
      color: #cd171e;
      font-weight: 600;
      margin-top: 40px;
      @media only screen and (max-width: 768px) {
        margin-top: 20px;
      }
    }
    @media only screen and (max-width: 768px) {
      text-align: center;
      font-size: 14px;
    }
  }
}
.buttons-container {
  margin-top: 30px;
  @media only screen and (max-width: 768px) {
    text-align: center;
  }
  button {
    display: inline-block;
    margin: 0 10px;
    font-size: 17px;
    min-width: 230px;
    padding: 17px 35px;
    @media only screen and (max-width: 768px) {
      margin: 0 0 15px 0;
      max-width: 400px;
      width: 100%;
    }
  }
}
.btn-skip {
  margin-top: 40px;
  @media only screen and (max-width: 768px) {
    margin-top: 10px;
  }
}
</style>